{
  "ui": {
    "feedback": "Votre avis",
    "credits": "Crédits",
    "currentMaintainer": "Maintenance actuelle",
    "maintainerPeriod": "Depuis 2026",
    "originalTeam": "Équipe originale",
    "creditsCampaigns": "Jungle et Noël",
    "moreSettings": "Autres réglages",
    "chooseLanguage": "Choisis ta langue",
    "notebookTools": "Outils du carnet",
    "visualGuide": "Guide en images",
    "templeSoon": "Bientôt disponible",
    "playAdventure": "Jouer",
    "story": "L’histoire",
    "loadingAdventure": "Préparons l’aventure…",
    "storyOpening": "Une sortie scolaire dans la jungle. Marco et Sophia explorent avec leurs amis. Un oiseau coloré attire Marco, qui le suit entre les arbres. Soudain, il est seul. Aide les explorateurs à retrouver leur chemin !",
    "storyEnding": "Marco et Sophia arrivent ensemble au temple perdu. Un visage mystérieux garde l’entrée. Une nouvelle aventure les attend !",
    "blockCategories": "Onglets du carnet",
    "actions": "Actions",
    "loops": "Boucles",
    "conditions": "Conditions",
    "title": "Run Marco! — Une aventure dans ton carnet",
    "home": "Accueil Run Marco",
    "map": "Carte de l’aventure",
    "worlds": "Choisis une aventure",
    "notebook": "Mon carnet",
    "notebookToggle": "Ouvrir ou fermer le carnet",
    "notebookOpen": "Ouvrir le carnet",
    "notebookClose": "Regarder le chemin",
    "page": "Page {number}",
    "level": "Parcours {number}",
    "run": "C’est parti !",
    "stop": "Arrêter",
    "step": "Un pas",
    "stepTitle": "Exécuter une instruction",
    "reset": "Revenir au départ",
    "add": "Ajouter",
    "addLabel": "Choisis un bloc à ajouter",
    "addHint": "Assemble tes blocs, puis appuie sur Jouer.",
    "undo": "Annuler",
    "clear": "Nouvelle page",
    "hint": "Un petit indice",
    "help": "Comment jouer",
    "settings": "Réglages",
    "language": "Langue du jeu",
    "blockLanguage": "Langue des blocs",
    "blockLanguageNote": "Tu peux choisir une autre langue pour les blocs.",
    "musicOn": "Activer le son",
    "musicOff": "Couper le son",
    "sound": "Musique et effets sonores",
    "speed": "Vitesse de l’aventure",
    "chooseExplorer": "Choisis ton explorateur",
    "explorer": "Explorateur",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Fermer",
    "done": "Explorons !",
    "loading": "Cherchons le chemin…",
    "loadError": "L’aventure n’a pas pu se charger. Recharge la page pour réessayer.",
    "imageError": "Certaines images n’ont pas pu se charger. Recharge la page.",
    "gemGoal": "Trouve la gemme",
    "goal": "Trouve l’étoile dorée",
    "cover": "Allume chaque case une seule fois",
    "lit": "{count} / {total} cases allumées",
    "explored": "{count} / {total} parcours explorés",
    "facing": "Direction : {direction} {arrow}",
    "boardLabel": "{name} sur {level}, direction {direction}. {steps}. {objective}.",
    "up": "haut",
    "down": "bas",
    "left": "gauche",
    "right": "droite",
    "steps_one": "{count} pas",
    "steps_other": "{count} pas",
    "blocks_one": "{count} bloc",
    "blocks_other": "{count} blocs",
    "stars_one": "{count} étoile",
    "stars_other": "{count} étoiles",
    "place": "Ajouter des blocs",
    "atEnd": "À la fin",
    "insideRepeat": "Dans la boucle {number}",
    "insideIf": "Dans le si {number}",
    "insideElse": "Dans le sinon {number}",
    "readyFirst": "Un petit pas. Ajoute un bloc pour avancer et c’est parti !",
    "ready": "Où allons-nous ? Prépare ton plan dans le carnet.",
    "back": "De retour au départ. Tes blocs sont prêts pour un nouvel essai.",
    "empty": "Ajoute d’abord un bloc dans ton carnet.",
    "win": "Tu as trouvé le chemin !",
    "winCover": "Tu as illuminé le chemin !",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Quelle aventure !",
    "simpler": "Peux-tu utiliser moins de blocs ?",
    "complete": "Parcours terminé ! Tes meilleures étoiles sont enregistrées.",
    "next": "Parcours suivant",
    "allWorlds": "D’autres aventures",
    "replay": "Rejouer",
    "shortGoal": "Presque ! Ajoute quelques blocs pour atteindre l’étoile.",
    "shortGem": "Presque ! Ajoute quelques blocs pour atteindre la gemme.",
    "shortCover": "Certaines cases sont encore éteintes. Comment les atteindre ?",
    "checking": "Observons le chemin…",
    "paused": "En pause. Jouer recommence depuis le début.",
    "going": "En route !",
    "stepped": "Un pas de plus. Appuie sur Un pas ou sur Jouer pour continuer.",
    "clueCover": "Pars d’un bord et suis toute la forme. Un saut passe au-dessus d’une case sans l’allumer.",
    "clueCondition": "Regarde le chemin devant toi. Une condition aide ton explorateur à choisir quoi faire.",
    "clueRepeat": "Quels pas se répètent ? Place ce motif dans une boucle.",
    "clueForward": "Avancer suit la direction de ton explorateur. Compte les cases jusqu’à l’étoile.",
    "clueGem": "Avancer suit la direction de ton explorateur. Compte les cases jusqu’à la gemme.",
    "clueTurn": "Tourner change la direction sans avancer. Suis le chemin avec ton doigt.",
    "mapNote": "Choisis un parcours. Tes meilleures étoiles sont conservées.",
    "mapLevel": "Parcours {number} : {name}. {stars}.",
    "locked": "Termine le parcours précédent pour débloquer celui-ci.",
    "soundBlocked": "Appuie sur le bouton du son pour écouter l’aventure.",
    "clearTitle": "Passer à une nouvelle page ?",
    "clearNote": "Les blocs de ce parcours seront effacés. Annuler peut les restaurer.",
    "keep": "Garder mes blocs",
    "clearConfirm": "Effacer les blocs",
    "fresh": "Une nouvelle page. Où ton prochain plan nous mènera-t-il ?",
    "localProgress": "Ta progression est enregistrée sur cet appareil.",
    "helpBuild": "Prépare un plan",
    "helpBuildText": "Glisse les blocs dans le carnet et assemble-les, ou touche un bloc pour l’ajouter. Choisis « Dans la boucle » pour y placer des pas.",
    "helpTurn": "Suis ton explorateur",
    "helpTurnText": "Avancer suit son regard. Gauche et droite font tourner sans avancer. Sauter parcourt deux cases.",
    "helpTry": "Essaie, regarde, recommence",
    "helpTryText": "Appuie sur Jouer pour essayer ton plan, ou sur Un pas pour une instruction. La flèche courbe revient au départ en gardant tes blocs.",
    "helpWorlds": "Chaque aventure a son objectif",
    "helpWorldsText": "Dans la jungle, trouve la gemme. À Noël, éclaire chaque case libre une seule fois. Dans le Temple et l’Égée, termine les réparations et les objectifs affichés, puis rejoins la sortie.",
    "noTrail": "Pas de chemin ici ! Essaie de tourner avant d’avancer.",
    "broken": "Ce pont est cassé. Peux-tu sauter par-dessus ?",
    "blocked": "Un obstacle bloque le chemin. Essaie un saut ou un autre trajet.",
    "alreadyLit": "Cette case est déjà allumée. Ne passe qu’une fois sur chaque case.",
    "loopError": "Ce plan se répète sans arrêt. Essaie de modifier la boucle.",
    "repeatError": "Choisis un nombre de répétitions entre 1 et 99.",
    "unsupported": "Retire le bloc non pris en charge et réessaie.",
    "connect": "Assemble les blocs en une seule chaîne, puis appuie sur Jouer.",
    "path": "chemin",
    "steps_many": "{count} pas",
    "blocks_many": "{count} blocs",
    "stars_many": "{count} étoiles",
    "backpack": "Sac à dos",
    "templeGems": "Gemmes du temple",
    "gemsCollected": "Gemmes : {count} / {total}",
    "gemsReady": "Toutes les gemmes sont réunies !",
    "aegeanTitle": "Les mystères de l’Égée",
    "harbour": "Port",
    "aegeanDescription": "Explore le port : répare les stations, réutilise les routines et transmets un nombre avec chaque commande.",
    "templeBetaNote": "Bêta · Les énigmes et les leçons sont en cours de révision",
    "aegeanBetaNote": "Bêta · Les 3 premiers niveaux du port",
    "seasonal": "Aventure saisonnière",
    "choosePreview": "Choisir un niveau d’aperçu",
    "repairs": "Réparations",
    "reachExit": "Atteindre la sortie",
    "taskRequirements": "Objectifs de la mission",
    "lessonGuided": "Exercice guidé · complète le programme fourni",
    "lessonRepair": "Débogage · corrige le programme fourni",
    "lessonChallenge": "Défi · crée ton propre programme",
    "acc_define_parameter": "Routine",
    "acc_call_argument": "Utiliser une routine",
    "acc_repeat_parameter": "Répéter avec l’entrée",
    "parameter": "paramètre",
    "argument": "envoyer",
    "callInput": "Entrée de cet appel",
    "inputWaiting": "Lance le programme ou avance pas à pas pour voir l’entrée suivante.",
    "argumentMismatch": "Une routine avec un paramètre nécessite un appel avec un nombre. Sans paramètre, utilise un appel ordinaire.",
    "unsetParameter": "Utilise le paramètre uniquement dans la routine qui le reçoit. Les paramètres sont séparés de la mémoire partagée.",
    "memoryObjective": "Vérifie le registre des réparations et les objectifs de sortie. Tout programme qui les remplit est accepté.",
    "gate": "Le passage est fermé. Vérifie les réparations inachevées.",
    "noPickup": "Place-toi sur l’outil avant de le ramasser.",
    "creditLead": "Direction d’équipe et développement logiciel",
    "creditArt": "Illustration et décors",
    "creditAnimation": "Animation",
    "creditUX": "Conception de l’interface et de l’expérience utilisateur",
    "creditDesign": "Conception du jeu",
    "creditStory": "Écriture de l’histoire",
    "creditAudio": "Musique et ingénierie du son",
    "lightLamp": "Allumer la lampe",
    "oilLamp": "Lampe à huile",
    "dustyStation": "station poussiéreuse",
    "betaLabel": "Bêta",
    "noLamp": "Place-toi sur une lampe éteinte avant de l’allumer.",
    "collected": "Outil ramassé · prêt à utiliser",
    "dustyPrompt": "Place-toi sur une station poussiéreuse avant d’utiliser la brosse.",
    "lampMissing": "Ramasse d’abord la lampe à huile. Regarde dans ton sac.",
    "recursiveRoutine": "Cette routine s’appelle elle-même. Utilise une autre routine ; les appels récursifs ne sont pas encore disponibles."
  },
  "content": {
    "jungle.title": "Expédition dans la jungle",
    "jungle.description": "Suis le chemin jusqu’au temple perdu.",
    "jungle-1": "Premiers pas",
    "jungle-2": "Un peu plus loin",
    "jungle-3": "Au coin du chemin",
    "jungle-4": "Change de direction",
    "jungle-5": "Suis le chemin",
    "jungle-6": "Un nouveau trajet",
    "jungle-7": "De nouveaux chemins",
    "jungle-8": "Carrefour dans la jungle",
    "jungle-9": "Trouve ton chemin",
    "jungle-10": "Anticipe",
    "jungle-11": "Le long chemin",
    "jungle-12": "Un trajet sinueux",
    "jungle-13": "Un saut audacieux",
    "jungle-14": "Des motifs apparaissent",
    "jungle-15": "Répète le rythme",
    "jungle-16": "Choisis un chemin",
    "jungle-17": "Regarde avant de sauter",
    "jungle-18": "Lis le chemin",
    "jungle-19": "Un détour malin",
    "jungle-20": "Sous la canopée",
    "jungle-21": "Bâtisseur de ponts",
    "jungle-22": "Au-delà de la rivière",
    "jungle-23": "Explore les ruines",
    "jungle-24": "Pierre et bois",
    "jungle-25": "Un plus grand saut",
    "jungle-26": "Suis les indices",
    "jungle-27": "Plus haut",
    "jungle-28": "Continue d’explorer",
    "jungle-29": "Chemins tortueux",
    "jungle-30": "Le jardin secret",
    "jungle-31": "Motifs cachés",
    "jungle-32": "Chemins anciens",
    "jungle-33": "Les derniers virages",
    "jungle-34": "Vers le temple",
    "jungle-35": "Presque arrivé",
    "jungle-36": "Le temple perdu",
    "winter.title": "Chemin d’hiver",
    "winter.description": "Éclaire chacune de tes empreintes.",
    "winter-1": "Pas dans la neige",
    "winter-2": "Une autre direction",
    "winter-3": "Coins gelés",
    "winter-4": "Le grand détour",
    "winter-5": "Flocon de neige",
    "winter-6": "Boucles d’hiver",
    "winter-7": "Explorateur des glaces",
    "winter-8": "Virages et détours",
    "winter-9": "Logique glacée",
    "winter-10": "Chercheur de motifs",
    "winter-11": "Maître du chemin",
    "winter-12": "Merveille d’hiver",
    "temple.title": "Le temple perdu",
    "temple.description": "Quarante salles reliées. Restaure un instrument céleste avec des outils, la mémoire et tes propres routines."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Corbeille vide",
    "OPEN_TRASH": "Ouvrir la corbeille",
    "BLOCK_LABEL_BEGIN_STACK": "Début de la pile",
    "WORKSPACE_LABEL_1_STACK": "1 pile de blocs",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 piles de blocs",
    "ARIA_TYPE_FIELD_NUMBER": "nombre",
    "ARIA_TYPE_FIELD_DROPDOWN": "liste déroulante",
    "ARIA_TYPE_FIELD_IMAGE": "image",
    "WORKSPACE_LABEL_PLAIN": "Mon carnet",
    "FIELD_LABEL_EDIT_PREFIX": "Modifier %1",
    "BLOCK_LABEL_HAS_INPUT": "contient une entrée",
    "BLOCK_LABEL_HAS_INPUTS": "contient des entrées",
    "BLOCK_LABEL_HAS_BRANCHES": "contient %1 branches",
    "FIELD_LABEL_OPTION_INDEX": "Option %1",
    "INPUT_LABEL_EMPTY": "Vide",
    "BLOCK_LABEL_DISABLED": "désactivé",
    "BLOCK_LABEL_COLLAPSED": "réduit",
    "BLOCK_LABEL_BEGIN_PREFIX": "Début : %1",
    "INPUT_LABEL_END_STATEMENT": "Fin : %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "texte",
    "ARIA_TYPE_FIELD_INPUT": "entrée",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nom de l’entrée",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nom de la routine"
  }
}
